function handleAjaxUnauthorized() {
  jQuery(function () {
    $(document).ajaxError(function (event, request, settings) {
      if (request.status === 401) {
        window.location.replace(route('app.login', { 'unauthorized': true }));
      }
    });
  })
}

exports.init = handleAjaxUnauthorized;
